import React from 'react'
import { Row, Col } from 'antd'

function Section2({ data }) {
    return (
        <div className="section section2"
            style={{
                background: data?.bg ? `url(${data?.bg})` : "#17161a",
            }} >
            <Row justify='space-between' align='middle' >
                <Col md={24} lg={12}>
                    <img

                        src={data?.img}
                        alt="img"
                        loading="lazy"
                        srcSet={data?.srcset}
                        sizes={data?.sizes}
                        height="100%"

                    />
                </Col>
                <Col md={24} lg={12}>
                    <h3 dangerouslySetInnerHTML={{ __html: data?.h3 }} />
                    <h1 dangerouslySetInnerHTML={{ __html: data?.h1 }} />
                    {data?.h2 && <h2 dangerouslySetInnerHTML={{ __html: data?.h2 }} />}
                    {/* {data?.h2 && <img src={h2Bottom} alt="svg" />} */}
                    <p dangerouslySetInnerHTML={{ __html: data?.p }} />
                    <p className='pSmall' dangerouslySetInnerHTML={{ __html: data?.pSmall }} />
                </Col>

            </Row>
        </div>
    )
}

export default Section2